export default "__VITE_ASSET__DGk9nXLz__"